/**
 * @generated SignedSource<<448232c1772dbcdec94e1c8ce936e387>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type Avatar_user$data = {
  readonly displayName: string | null | undefined;
  readonly photoURL: string | null | undefined;
  readonly " $fragmentType": "Avatar_user";
};
export type Avatar_user$key = {
  readonly " $data"?: Avatar_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"Avatar_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "Avatar_user",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "displayName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "photoURL",
      "storageKey": null
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "1c81abdff1fc529064f4bcd736295c0d";

export default node;
